import { render, staticRenderFns } from "./MyMsgList.vue?vue&type=template&id=103d3b6f&scoped=true&"
import script from "./MyMsgList.vue?vue&type=script&lang=js&"
export * from "./MyMsgList.vue?vue&type=script&lang=js&"
import style0 from "./MyMsgList.vue?vue&type=style&index=0&id=103d3b6f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "103d3b6f",
  null
  
)

export default component.exports